import { render, staticRenderFns } from "./AgeAverageInput.vue?vue&type=template&id=944a8afa&"
import script from "./AgeAverageInput.vue?vue&type=script&lang=js&"
export * from "./AgeAverageInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports